import L from "leaflet"
import "leaflet/dist/leaflet.css"

const pinSvg = `<svg class="cursor-pointer transition-transform duration-200" width="28" height="36" viewBox="0 0 28 36" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <mask id="pin-hole">
      <rect width="100%" height="100%" fill="white"/>
      <circle cx="14" cy="14" r="5" fill="black"/>
    </mask>
  </defs>
  <path
    d="M14 36s11-12 11-21A11 11 0 1 0 3 15c0 9 11 21 11 21z"
    fill="#D94841"
    mask="url(#pin-hole)"
  />
</svg>`

const pinIcon = L.divIcon({
    html: pinSvg,
    className: "",
    iconSize: [28, 36],
    iconAnchor: [14, 36],
    popupAnchor: [0, -36],
})

function initMap(el) {
    const features = JSON.parse(el.dataset.features || "[]")
    if (!features.length) return

    const map = L.map(el, {
        scrollWheelZoom: false,
        touchZoom: false,
        attributionControl: false,
    })

    L.control.attribution({ prefix: 'Leaflet' }).addTo(map)

    L.tileLayer(
        "https://services.arcgisonline.com/arcgis/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}"
    ).addTo(map)

    L.tileLayer(
        "https://{s}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}.png"
    ).addTo(map)

    const bounds = L.latLngBounds(
        features.map(f => [f.geometry.coordinates[1], f.geometry.coordinates[0]])
    )
    map.fitBounds(bounds, { padding: [50, 50], maxZoom: 14 })

    const markers = {}

    features.forEach(f => {
        const coords = [f.geometry.coordinates[1], f.geometry.coordinates[0]]

        const popupContent = `
            <div class="p-3 max-w-xs bg-white">
                <h3 class="font-semibold text-marva text-base mb-1">${f.properties.title}</h3>
                <p class="text-sm text-gray-600 mb-2">${f.properties.description}</p>
            </div>
        `

        const marker = L.marker(coords, { icon: pinIcon })
            .addTo(map)
            .bindPopup(popupContent, { closeButton: false })

        const id = f.properties.id ?? f.properties.title
        markers[id] = marker
    })

    // Card ↔ marker interaction
    document.querySelectorAll('.contact-card-wrapper').forEach(wrapper => {
        const cardId = wrapper.id.replace('contact-for-marker-', '')
        const marker = markers[cardId]
        if (!marker) return

        marker.on('popupopen', () => {
            document.querySelectorAll('.contact-card-wrapper').forEach(card => {
                card.classList.remove('ring-2', 'ring-primary')
            })
            wrapper.classList.add('ring-2', 'ring-primary')
        })

        marker.on('popupclose', () => {
            wrapper.classList.remove('ring-2', 'ring-primary')
        })

        wrapper.addEventListener('click', () => {
            map.closePopup()
            marker.openPopup()
            wrapper.classList.add('ring-2', 'ring-primary')
        })
    })
}

// Auto-init all [data-leaflet-map] elements
document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-leaflet-map]").forEach(initMap)
})
